// Mailbox.jsx
import React, { useContext, useEffect, useState, useCallback } from "react";
import { Box, Divider, Grid, Typography } from "@mui/material";

import api from "../api/axios";
import Swal from "sweetalert2";
import dayjs from "dayjs";

import { UserContext } from "../Components/Context/Context";
import SidebarMailbox from "./components/SidebarMailbox";
import FiltersBar from "./components/FiltersBar";
import MessageViewer from "./components/MessageViewer";
import MessageComposer from "./components/MessageComposer";

import { useRichTextEditor } from "./components/Editor";

export default function Mailbox({
  dataCase,
  heighProp = false,
  insideCase = false,
}) {
  const { userData } = useContext(UserContext);
  const { user } = userData;

  // =====================
  // ESTADOS (SIN CAMBIOS)
  // =====================
  const [messages, setMessages] = useState([]);
  const [sentMessages, setSentMessages] = useState([]);

  const [companies, setCompanies] = useState([]);
  const [lawyers, setLawyers] = useState([
    { name: "Seleccionar", surname: "", id: 0 },
  ]);

  const [sendMode, setSendMode] = useState("lawyer");
  const [filter, setFilter] = useState("inbox");
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(false);

  const [newMsg, setNewMsg] = useState({ to: "", subject: "" });
  const [associatedOptions, setAssociatedOptions] = useState([]);

  const [paginationInbox, setPaginationInbox] = useState({
    page: 1,
    perPage: 10,
    last_page: 1,
    total: 0,
  });

  const [paginationSent, setPaginationSent] = useState({
    page: 1,
    perPage: 10,
    last_page: 1,
    total: 0,
  });

  const [sharedFilters, setSharedFilters] = useState({
    company_id: "",
    lawyer_id: "",
    subject: "",
    date_from: "",
    date_to: "",
    status: "",
  });

  const [applyToggle, setApplyToggle] = useState(false);
  const [flagCompanySelected, setFlagCompanySelected] = useState(false);
  const [changeOptionsFlag, setChangeOptionsFlag] = useState(false);

  const { editorState, onEditorChange, clearEditor, getHtmlFromEditor } =
    useRichTextEditor();

  // =====================
  // HELPERS / HANDLERS
  // =====================
  const resetPagesOnFilterChange = () => {
    setPaginationInbox((p) => ({ ...p, page: 1 }));
    setPaginationSent((p) => ({ ...p, page: 1 }));
  };

  const openMessage = (msg) => {
    setSelected(msg);
    if (msg.status === "unread") {
      if (filter === "inbox") {
        setMessages((prev) =>
          prev.map((m) => (m.id === msg.id ? { ...m, status: "read" } : m)),
        );
      } else {
        setSentMessages((prev) =>
          prev.map((m) => (m.id === msg.id ? { ...m, status: "read" } : m)),
        );
      }
    }
  };

  // =====================
  // FETCH MENSAJES (IGUAL)
  // =====================
  const getMessages = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.post(
        `${process.env.REACT_APP_API_URL}/messages`,
        {
          page: filter === "inbox" ? paginationInbox.page : paginationSent.page,
          objPerPage:
            filter === "inbox"
              ? paginationInbox.perPage
              : paginationSent.perPage,
          subject: sharedFilters.subject || false,
          status: sharedFilters.status || false,
          user_id: sharedFilters.lawyer_id || false,
          case_id: dataCase?.id || false,
          inside_flag: !!dataCase?.id,
          date_from: sharedFilters.date_from
            ? dayjs(sharedFilters.date_from, "DD-MM-YYYY").format(
                "YYYY-MM-DD 00:00:00",
              )
            : false,
          date_to: sharedFilters.date_to
            ? dayjs(sharedFilters.date_to, "DD-MM-YYYY").format(
                "YYYY-MM-DD 00:00:00",
              )
            : false,
        },
      );

      const {
        messages_to,
        messages_from,
        companies: companiesResp,
        cases_associated,
      } = data;

      const unifiedOptions = cases_associated?.flatMap((item) => {
        const options = [];

        if (item.clients_relation) {
          options.push({
            id: item.clients_relation.id,
            type: "client",
            name: item.clients_relation.name,
            surname: item.clients_relation.surname,
            email: item.clients_relation.email,
            case_id: item.id,
            original: item,
          });
        }

        if (item.lawyers_relation) {
          options.push({
            id: item.lawyers_relation.id,
            type: "lawyer",
            name: item.lawyers_relation.name,
            surname: item.lawyers_relation.surname,
            email: item.lawyers_relation.email,
            case_id: item.id,
            original: item,
            isCaseLawyer: true, // 👈 CLAVE
          });
        }

        return options;
      });

      console.log(unifiedOptions);
      if (insideCase) {
        setAssociatedOptions(unifiedOptions || []);
      }

      if (messages_to) {
        setMessages(messages_to.data || []);
        setPaginationInbox((p) => ({
          ...p,
          page: messages_to.current_page,
          perPage: messages_to.per_page,
          last_page: messages_to.last_page,
          total: messages_to.total,
        }));
      }

      if (messages_from) {
        setSentMessages(messages_from.data || []);
        setPaginationSent((p) => ({ ...p, ...messages_from }));
      }

      if (companiesResp) {
        setCompanies([{ company_name: "Seleccionar" }, ...companiesResp]);
      }
    } catch (error) {
      Swal.fire("Error", "No se pudo obtener mensajes", "error");
    } finally {
      setLoading(false);
    }
  }, [
    paginationInbox.page,
    paginationSent.page,
    applyToggle,
    sharedFilters.subject,
    sharedFilters.status,
    sharedFilters.lawyer_id,
    sharedFilters.date_from,
    sharedFilters.date_to,
  ]);

  const sendMessage = async () => {
    const html = getHtmlFromEditor();

    const to =
      insideCase && sendMode === "client" ? filteredOptions?.[0] : newMsg.to;

    const subject = newMsg.subject?.trim() || "";

    console.log(to);

    if (!to || !subject || !html) {
      Swal.fire("Campos incompletos", "Completa todos los campos", "warning");
      return;
    }

    const { isConfirmed } = await Swal.fire({
      icon: "question",
      title: "¿Enviar mensaje?",
      showCancelButton: true,
      confirmButtonText: "Enviar",
      cancelButtonText: "Cancelar",
    });

    if (!isConfirmed) return;

    const payload = {
      date: new Date().toISOString().slice(0, 10),
      from: user.id,
      to: to.id,
      to_type: to.type,
      subject,
      message: html,
      status: "unread",
      email: to.email,
      ...(insideCase && { case_id: to.case_id }),
    };

    Swal.fire({
      title: "Enviando mensaje...",
      text: "Por favor espera",
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      timer: 10000, // seguridad por si algo falla
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const res = await api.post(
        `${process.env.REACT_APP_API_URL}/messages/store`,
        payload,
      );

      // Cerrar loading
      Swal.close();

      setSentMessages((prev) => [res.data.message, ...prev]);
      clearEditor();
      setNewMsg({ to: "", subject: "" });
      setSelected(res.data.message);
      setFilter("sent");

      Swal.fire({
        icon: "success",
        title: "Enviado",
        text: "Mensaje enviado correctamente",
        timer: 2500,
        showConfirmButton: false,
      });
    } catch (error) {
      console.log(error);
      Swal.close();

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo enviar el mensaje",
      });
    }
  };

  // Abogado del caso
  const caseLawyers = associatedOptions.filter(
    (o) => o.type === "lawyer" && o.isCaseLawyer,
  );

  // Resto de abogados
  const otherLawyers = lawyers.filter(
    (l) => !associatedOptions.some((a) => a.type === "lawyer" && a.id === l.id),
  );

  // 👉 ORDEN FINAL
  const filteredOptions = insideCase
    ? sendMode === "client"
      ? associatedOptions.filter((o) => o.type === "client")
      : [
          // 1️⃣ Primer abogado NO seleccionado
          ...otherLawyers.slice(0, 1),

          // 2️⃣ Abogado del caso (seleccionado)
          ...caseLawyers,

          // 3️⃣ Resto
          ...otherLawyers.slice(1),
        ]
    : lawyers;

  const filterDataByCompany = (company_id, flagFromCompanyInput = false) => {
    console.log(company_id && company_id !== 0);
    console.log(company_id, company_id !== 0);

    if (company_id && company_id !== 0) {
      try {
        let queryUrl = `${process.env.REACT_APP_API_URL}/users/searchdatabycompany`;

        api.post(queryUrl, { company: company_id }).then((response) => {
          if (response.data) {
            const { lawyers } = response.data;

            console.log(response.data);

            setLawyers((prevData) => [
              { name: "Seleccionar", surname: "", id: 0 },
              ...lawyers,
            ]);

            setFlagCompanySelected(true);
            setChangeOptionsFlag(!changeOptionsFlag);
          }
        });
      } catch (error) {
        console.log(error);
      }
    } else {
      // Si no hay empresa seleccionada, limpiar las opciones y bloquear los campos
      setFlagCompanySelected(false);
    }
  };

  useEffect(() => {
    getMessages();
  }, [getMessages]);

  useEffect(() => {
    if (!insideCase && sendMode === "client") {
      setSendMode("lawyer");
      setNewMsg((p) => ({ ...p, to: "" }));
    }
  }, [insideCase, sendMode]);

  useEffect(() => {
    if (insideCase && sendMode === "client") {
      const client = associatedOptions.find((o) => o.type === "client");
      if (client) {
        setNewMsg((prev) => ({ ...prev, to: client }));
      }
    }
  }, [insideCase, sendMode, associatedOptions]);

  useEffect(() => {
    if (
      insideCase &&
      sendMode === "lawyer" &&
      (!newMsg.to || newMsg.to.type !== "lawyer")
    ) {
      const caseLawyer = associatedOptions.find(
        (o) => o.type === "lawyer" && o.isCaseLawyer,
      );

      if (caseLawyer) {
        setNewMsg((prev) => ({
          ...prev,
          to: caseLawyer,
        }));
      }
    }
  }, [insideCase, sendMode, associatedOptions]);

  // =====================
  // RENDER
  // =====================
  return (
    <Box
      sx={{
        padding: "20px",
        width: insideCase ? "100%" : "unset",
      }}>
      <Grid
        container
        sx={{
          minHeight: heighProp || "unset",
          borderRadius: "4px",
          boxShadow: "0px 0px 10px -3px gray",
        }}
        bgcolor="#fff">
        {/* SIDEBAR */}
        <Grid item xs={4} sx={{ p: 2 }}>
          <SidebarMailbox
            loading={loading}
            filter={filter}
            setFilter={setFilter}
            messages={filter === "inbox" ? messages : sentMessages}
            pagination={filter === "inbox" ? paginationInbox : paginationSent}
            openMessage={openMessage}
            setSelected={setSelected}
          />
        </Grid>

        {/* DIVIDER */}
        {/* <Divider orientation="vertical" flexItem /> */}

        {/* CONTENIDO DERECHO */}
        <Grid item xs={8} container direction="column" sx={{ p: 2, gap: 2 }}>
          {/* FILTROS */}
          <Grid item>
            <FiltersBar
              sharedFilters={sharedFilters}
              setSharedFilters={setSharedFilters}
              lawyers={lawyers}
              handleClear={() => {
                resetPagesOnFilterChange();
                setApplyToggle((t) => !t);
              }}
              handleApply={() => {
                resetPagesOnFilterChange();
                setApplyToggle((t) => !t);
              }}
            />
          </Grid>

          {/* CONTENIDO */}
          <Grid item>
            {!selected && (
              <Typography variant="h5" color="text.secondary">
                Selecciona un mensaje
              </Typography>
            )}

            {selected && selected !== "compose" && (
              <MessageViewer
                selected={selected}
                filter={filter}
                insideCase={insideCase}
              />
            )}

            {selected === "compose" && (
              <MessageComposer
                {...{
                  companies,
                  lawyers,
                  sendMode,
                  setSendMode,
                  newMsg,
                  setNewMsg,
                  editorState,
                  onEditorChange,
                  clearEditor,
                  getHtmlFromEditor,
                  flagCompanySelected,
                  user,
                  filterDataByCompany,
                  insideCase,
                  filteredOptions,
                  sendMessage,
                }}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
